import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-173f2ccb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "functionSelect flex-center" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "search-form" }
const _hoisted_6 = {
  key: 0,
  class: "search-item"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "search-item"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_10 = { class: "flex-ter" }
const _hoisted_11 = { class: "strength_level" }

import { ref, watch, onMounted, nextTick } from 'vue'
import { t } from '@/plugins/i18n'
import SearchSort from './searchSort.vue'
import { MarketType, ModelValProps, PlatformTypeEnum, VVICmodelvalprops, VvicPlatformTypeEnum, WsyPlatformTypeEnum } from '../const'
import PriceRange from '@/components/common/PriceRange.vue'
import { supplierShopListMajorCate } from '@/apis/goods'
import { Warning } from '@element-plus/icons-vue'
import { marketGroupTreeList } from '@/apis/market'
import { useSite2Station } from '@/store'
import { Site } from '@/common/const'
type PriceProps = Record<string, number | undefined>
// 价格筛选范围

export default /*#__PURE__*/_defineComponent({
  props: ['type', 'filterClassify'],
  emits: ['change'],
  setup(__props, { emit }) {

const props = __props



const riceRangeVal = ref<PriceProps>({
})
// tabs初始化
const tabsInitVal = {
  [MarketType.ZSP]: { navTab: MarketType.ZSP, areaCodes: VvicPlatformTypeEnum['VC-SPB'], sortType: 'update_time' },
  [MarketType.ZDK]: {
    navTab: MarketType.ZDK,
    sortType: 'default'
  }
}

// 搜索表单值
const searchModel = ref<VVICmodelvalprops>({ ...tabsInitVal[MarketType.ZSP] })
// 确定价格范围
const setRange = ({ minPrice, maxPrice }: PriceProps) => {
  searchModel.value = { ...searchModel.value, sellPriceStart: minPrice, sellPriceEnd: maxPrice }
}

const chagneCateCode1 = (e: string) => {
  searchModel.value.cateCode2 = ''
  const second = firstClassify.value?.find((i: any) => i?.value === e)?.children
  secondClassify.value = second
  // searchModel.value.cateCode2 = second?.[0]?.value
}

// 搜图网切换分类
const changeVCAreaCodes = (e: { paneName: VvicPlatformTypeEnum }) => {
  const { navTab } = searchModel.value
  if (navTab === MarketType.ZSP) {
    if (e.paneName === VvicPlatformTypeEnum['VC-SPB']) {
      searchModel.value = { ...searchModel.value, areaCodes: VvicPlatformTypeEnum['VC-SPB'], cateCode: props.filterClassify?.[0]?.value }
    } else {
      const first = firstClassify?.value?.[0]
      const second = first?.children ?? []
      secondClassify.value = second
      delete searchModel.value.cateCode1
      delete searchModel.value.cateCode2
      searchModel.value = { ...searchModel.value, areaCodes: e.paneName, cateCode1: first?.value }
    }
  } else {
    searchModel.value = { ...searchModel.value }
  }
}

// 搜款网
const VCTabs = [
  {
    label: t('商品榜'),
    value: VvicPlatformTypeEnum['VC-SPB']
  }, {
    label: t('每日新品'),
    value: VvicPlatformTypeEnum['VC-MRXP']
  }, {
    label: t('七日热卖'),
    value: VvicPlatformTypeEnum['VC-QRRK']
  }, {
    label: t('现货专区'),
    value: VvicPlatformTypeEnum['VC-XHZQ']
  }
]

// 排序列表
const rankMethod = [
  {
    label: t('综合排序'),
    value: 'update_time'
  }, {
    label: t('价格排序'),
    value: 'product_sell_price'
  }
]

/** 类型选择 */
const functionSelectClick = (e: MarketType) => {
  if (searchModel.value.navTab === e) return
  searchModel.value = { ...tabsInitVal[e] }
}

watch(() => props.filterClassify, (val) => {
  searchModel.value = { ...searchModel.value, cateCode: val?.[0]?.cateCode }
}, {
  deep: true
})

// 监听搜索值
watch(() => searchModel.value, (val) => {
  console.log(val, 'searchModel.value')
  riceRangeVal.value = {
    minPrice: val.sellPriceStart,
    maxPrice: val.sellPriceEnd
  }
  if (searchModel.value) {
    emit('change', searchModel.value)
  }
}, {
  deep: true
})

// 功能切换
const functionSelectList = [
  {
    name: t('找商品'),
    activeIcon: 'https://static-s.theckb.com/BusinessMarket/Client/market/market_commodity_select_con.svg',
    inactiveIcon: 'https://static-s.theckb.com/BusinessMarket/Client/market/market_commodity_icon.svg',
    value: MarketType.ZSP
  },
  {
    name: t('找档口'),
    activeIcon: 'https://static-s.theckb.com/BusinessMarket/Client/market/market_shop_select_icon.svg',
    inactiveIcon: 'https://static-s.theckb.com/BusinessMarket/Client/market/market_shop_icon.svg',
    value: MarketType.ZDK
  }
]

// ------------------档口逻辑-------

// 档口排序
const stallRank = [
  {
    label: t('默认排序'),
    value: 'default'
  },
  {
    label: t('平台销售额'),
    value: 'platform_sales'
  }
]

// 档口-主营类型
const mainCategory = ref<any[]>([])
// 每日新品/七日热卖/现货专区分类
const firstClassify = ref()
const secondClassify = ref()

const stationCode = useSite2Station()
onMounted(async () => {
  const res = await marketGroupTreeList({ platformType: PlatformTypeEnum.VC })
  const list = (res.data ?? []).map((i: any) => {
    const label = {
      [Site.JA]: i.cateNameJa,
      [Site.KO]: i!.cateNameKo,
      [Site.EN]: i!.cateNameEn
    }[stationCode] as string
    let third: any[] = [];
    (i?.children ?? []).forEach((j: any) => {
      third = third.concat(j.children)
    })
    return {
      label: label ?? i?.cateName,
      value: i.cateCode,
      children: (third ?? []).map((j: any) => {
        const label = {
          [Site.JA]: j.cateNameJa,
          [Site.KO]: j!.cateNameKo,
          [Site.EN]: j!.cateNameEn
        }[stationCode] as string
        return {
          label: label ?? j.cateName,
          value: j.cateCode
        }
      })
    }
  })
  firstClassify.value = [{
    label: t('全部_'),
    value: undefined
  }, ...list]

  nextTick(() => {
    console.log(firstClassify.value, 'firstClassify.value')
  })
  secondClassify.value = [{
    label: t('全部_'),
    value: undefined
  }, ...list?.[0]?.children ?? []]

  const res1 = await supplierShopListMajorCate({ platformType: PlatformTypeEnum.VC })
  mainCategory.value = [
    {
      label: t('全部_'),
      value: undefined
    }, ...res1.data.map((item: any) => {
      return {
        label: item,
        value: item
      }
    })
  ]
})


return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(functionSelectList, (item) => {
        return _createElementVNode("div", {
          onClick: ($event: any) => (functionSelectClick(item.value)),
          key: item.name,
          class: _normalizeClass(["tab", item.value === searchModel.value.navTab ? 'active' : ''])
        }, [
          _createElementVNode("img", {
            class: "icon",
            src: item.value === searchModel.value.navTab ? item.activeIcon : item.inactiveIcon,
            alt: ""
          }, null, 8, _hoisted_4),
          _createTextVNode(_toDisplayString(item.name), 1)
        ], 10, _hoisted_3)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (searchModel.value.navTab === _unref(MarketType).ZSP)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_el_tabs, {
              onTabClick: changeVCAreaCodes,
              modelValue: searchModel.value.areaCodes,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchModel.value.areaCodes) = $event)),
              class: "search-tabs"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(VCTabs, (item) => {
                  return _createVNode(_component_el_tab_pane, {
                    label: item.label,
                    name: item.value,
                    key: item.value
                  }, null, 8, ["label", "name"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (searchModel.value.areaCodes !== _unref(VvicPlatformTypeEnum)['VC-SPB'])
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(SearchSort, {
                    key: "firstClassify",
                    startTop: true,
                    onChange: chagneCateCode1,
                    options: firstClassify.value,
                    value: searchModel.value.cateCode1,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchModel.value.cateCode1) = $event)),
                    label: _unref(t)('一级分类')
                  }, null, 8, ["options", "value", "label"]),
                  (secondClassify.value?.length)
                    ? (_openBlock(), _createBlock(SearchSort, {
                        key: "secondClassify",
                        startTop: true,
                        options: secondClassify.value,
                        value: searchModel.value.cateCode2,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchModel.value.cateCode2) = $event)),
                        label: _unref(t)('二级分类')
                      }, null, 8, ["options", "value", "label"]))
                    : _createCommentVNode("", true),
                  _createVNode(SearchSort, {
                    key: "sortType",
                    options: rankMethod,
                    value: searchModel.value.sortType,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((searchModel.value.sortType) = $event)),
                    label: _unref(t)('排序方式')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(PriceRange, {
                        min: riceRangeVal.value.minPrice,
                        "onUpdate:min": _cache[3] || (_cache[3] = ($event: any) => ((riceRangeVal.value.minPrice) = $event)),
                        max: riceRangeVal.value.maxPrice,
                        "onUpdate:max": _cache[4] || (_cache[4] = ($event: any) => ((riceRangeVal.value.maxPrice) = $event))
                      }, null, 8, ["min", "max"]),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (setRange(riceRangeVal.value))),
                        style: {"margin-left":"50px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "label"])
                ]))
              : _createCommentVNode("", true),
            (Boolean(__props.filterClassify?.length) && searchModel.value.areaCodes === _unref(VvicPlatformTypeEnum)['VC-SPB'])
              ? (_openBlock(), _createBlock(SearchSort, {
                  key: "filterClassify",
                  startTop: true,
                  options: __props.filterClassify,
                  value: searchModel.value.cateCode,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((searchModel.value.cateCode) = $event))
                }, null, 8, ["options", "value"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (searchModel.value.navTab === _unref(MarketType).ZDK)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(SearchSort, {
              key: "mainCategory",
              startTop: true,
              label: _unref(t)("主营类目"),
              options: mainCategory.value,
              value: searchModel.value.shopMajorCateName,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((searchModel.value.shopMajorCateName) = $event))
            }, null, 8, ["label", "options", "value"]),
            _hoisted_9,
            _createVNode(SearchSort, {
              key: "stallRank",
              label: _unref(t)("档口排序"),
              options: stallRank,
              value: searchModel.value.sortType,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((searchModel.value.sortType) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: searchModel.value.strongSupplier,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((searchModel.value.strongSupplier) = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('实力档口')), 1),
                      _createVNode(_component_el_tooltip, {
                        effect: "light",
                        content: _unref(t)("根据档口的缺货率、次品率、发货到仓及时率得出的评分较高的档口"),
                        placement: "top-start"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Warning))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["content"])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label", "value"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})